import { useMutation } from '@tanstack/react-query';
import apiClient from 'core/services/apiClient/apiClient';

export const usePostRest = <TPostResult, TBody>(pathURL: string) => {
  return useMutation<TPostResult, Error, TBody>({
    mutationFn: async (body) => {
      const { data } = await apiClient.post<TPostResult>(pathURL, body);
      return data;
    }
  });
};
